import { ISeriesPrototype, IUpdateSeries } from '@/types/series.types';
import { Patch } from '../helpers';
import { SeriesPath } from './path';

export default function UpdateSeries(series: IUpdateSeries) {
  return Patch<ISeriesPrototype>({
    path: SeriesPath(series.channel, `/${series.uuid}`),
    body: series,
  });
}
